export default function ArrowUpRightIcon({ classNames }: { classNames?: string }) {
  return (
    <svg
      className={`SvgIcon${classNames ? ` ${classNames}` : ""}`}
      width="19"
      height="20"
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.7058 13.7223C13.4406 13.7223 13.1976 13.6118 13.0208 13.435C12.8219 13.2362 12.7114 12.9931 12.7114 12.7279V8.08753L5.94973 14.8492C5.55198 15.247 4.91116 15.2249 4.53551 14.8492C4.18196 14.4957 4.13777 13.8328 4.53551 13.435L11.2972 6.67332L6.63474 6.65122C6.08231 6.67332 5.61827 6.20928 5.64037 5.65685C5.61827 5.10443 6.08231 4.64039 6.63474 4.66249H13.7058C14.2582 4.64039 14.7223 5.10443 14.7002 5.65685V12.7279C14.7223 13.2803 14.2582 13.7444 13.7058 13.7223Z"
        fill="#108757"
      />
      currentColor
    </svg>
  );
}
